import { Serie } from "@nivo/line";
import * as React from "react";
import { PressureDataPoint, PressureTestFlow } from "../../misc/api/apiTypes";
import Alert, { AlertCategoryEnum } from "../../misc/components/Alert";
import { PressureTimeGraph } from "./PressureTimeGraph";

interface PressureGraphsProps {
    type: 'MIP' | 'MEP' | 'SNIP';
    data: PressureTestFlow[];
}

export const PressureGraphs = ({ type, data }: PressureGraphsProps) => {
    const pressureValues = data.flatMap(t => t.PressureData.map(vd => vd.Pressure));

    const pressureMin = Math.min(...pressureValues);
    const pressureMax = Math.max(...pressureValues);

    const sortedData = data.filter(x => x.IsDisplayed).sort((a, b) => b.TestNumber - a.TestNumber);

    const ptChartData: Serie[] = sortedData
        .map((d) => {
            return {
                id: `Test ${d.TestNumber}`,
                color: d.ColorHex,
                data: d["PressureData"].map(pt => ({
                    x: pt.Time,
                    y: pt.Pressure,
                }))
            }
        });

    if (ptChartData.length === 0)
        return <Alert show={true} category={AlertCategoryEnum.Danger}>There is no chart data to display. The {type} session may be incomplete.</Alert>

    const specificTimePeriod: number[] = ptChartData.flatMap(t => t.data.map(d => d.x)) as number[];
    const timeMin = Math.min(...specificTimePeriod);
    const timeMax = Math.max(...specificTimePeriod);

    if (sortedData.length === 0)
        return <Alert show={true} category={AlertCategoryEnum.Info}>There are no tests currently selected for display</Alert>

    return (
        <>
            <div id="PressureTimeChartWrapper" className="col-md-6" style={{ height: 600 + 'px' }}>
                <h4>Pressure / Time Graph</h4>
                <PressureTimeGraph data={ptChartData} minPressure={pressureMin} maxPressure={pressureMax} minTime={timeMin} maxTime={timeMax} />
            </div>
        </>
    );
}